import React, { forwardRef, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";
import { Fade } from "@mui/material";
import theme from "../theme";
import Title from "./Title";
import { Box } from "@mui/system";

const Page = forwardRef(({ children, title = "", button, icon, noMargin, ...rest }, ref) => {
	const [appear, setApperar] = useState(false);
	useEffect(() => {
		window.scrollTo(0, 0);
		setTimeout(() => {
			setApperar(true);
		}, 300);
	}, []);

	return (
		<div
			ref={ref}
			{...rest}
			style={{
				position: "relative",
			}}
		>
			<Helmet>
				<title>Patum Infantil - {title}</title>
			</Helmet>
			<Title button={button} icon={icon}>
				{title}
			</Title>
			<Fade in={appear} timeout={400}>
				<div
					style={{
						overflow: "hidden",
						backgroundColor: theme.color.background_dark,
					}}
				>
					<Box mt={6} zIndex={0}>
						{children}
					</Box>
				</div>
			</Fade>
		</div>
	);
});

Page.propTypes = {
	children: PropTypes.node.isRequired,
	title: PropTypes.string,
	button: PropTypes.object,
};

export default Page;
